module.exports = __webpack_public_path__ + "img/source04_bg1.66fb5010.png";